import {gsap} from "gsap";

class Roulette{
    constructor() {
        this.items = {
            0: {
                title: '게이밍 노트북 응모권',
                deg: 72
            },
            1: {
                title: '최고급 보상 응모권',
                deg: 360
            },
            2: {
                title: '응원봉 1개',
                deg: 288
            },
            3: {
                title: '응원봉 2개',
                deg: 216
            },
            4: {
                title: '응원봉 3개',
                deg: 144
            }
        };
        this.rouletteBox = $('.p-roulette__box');
        this.current = {};
        this.rotation = {
            initDeg: 360/Object.keys(this.items).length,
            motionDeg: 360*3,
            bufferDeg: 5,
            prevDeg: '',
            currDeg: ''
        };

        this.init();
        this.bindEvent();
    }

    init(){
        this.rotation.currDeg = this.items[0].deg;
        this.rotation.prevDeg = 0;
    }

    set(idx){
        $('.p-roulette__btn-click').prop('disabled', true);
        this.current = this.items[idx];
        this.rotation.currDeg = Math.round(gsap.utils.random(this.current.deg - this.rotation.initDeg + this.rotation.bufferDeg, this.current.deg - this.rotation.bufferDeg )) - (this.rotation.initDeg / 2);
    }

    action(idx){
        idx ? this.set(idx) : this.set(0);
        gsap.fromTo(this.rouletteBox, { rotation: this.rotation.prevDeg },{ duration: 3, rotation: this.rotation.currDeg + this.rotation.motionDeg, ease: 'power4.inOut', onComplete: ()=>this.complete() });
    }

    close(){
        $('.p-roulette__btn-click').prop('disabled', false);
        $('.p-popup').remove();
    }

    complete(){
        this.rotation.prevDeg = this.rotation.currDeg;
        this.popup('complete');
    }

    popup( target ){
        if( $('.p-popup').length ) this.close();
        $('.p-roulette').append( this.tmpl(target) );
    }

    tmpl( target ){
        let _tmpl;
        switch (target){
            case 'complete':
                _tmpl = `
                <div class="p-popup p-popup--complete p-roulette__layer">
                    <p>축하합니다. 당첨되셨습니다.</p>
                    <strong class="p-popup__text">${this.current.title}</strong>
                    <button class="p-popup__btn-done">확인</button>
                    <button class="p-popup__btn-close">닫기</button>
                </div>
                `;
                break;
            case 'service':
                _tmpl = `
                <div class="p-popup p-popup--service p-roulette__layer">
                    <p>plaync서비스 선택 이후에 도전 가능합니다.</p>
                    <button class="p-popup__btn-done">확인</button>
                    <button class="p-popup__btn-close">닫기</button>
                </div>
                `;
                break;
            case 'target':
                _tmpl = `
                <div class="p-popup p-popup--target p-roulette__layer">
                    <p>참여대상이 아닙니다.</p>
                    <button class="p-popup__btn-done">확인</button>
                    <button class="p-popup__btn-close">닫기</button>
                </div>
                `;
                break;
            case 'error':
                _tmpl = `
                <div class="p-popup p-popup--error p-roulette__layer">
                    <p>오류가 발생하였스니다. 잠시 후 시도해 주세요!</p>
                    <button class="p-popup__btn-done">확인</button>
                    <button class="p-popup__btn-close">닫기</button>
                </div>
                `;
                break;
            case 'loading':
                _tmpl = `
                <div class="p-popup p-popup--loading p-roulette__layer">
                    <p>로딩중입니다.</p>
                    <button class="p-popup__btn-done">확인</button>
                    <button class="p-popup__btn-close">닫기</button>
                </div>
                `;
                break;
        }
        return _tmpl;
    }

    bindEvent(){
        $(document).on('click', '.p-popup__btn-done, .p-popup__btn-close', this.close );
    }
}

export default Roulette;


// WEBPACK FOOTER //
// ./src/js/_rouletteGame.js